import { AnalyticsPlatform, Report } from "../types";

const analyticsStore: Map<string, Report> = new Map<string, Report>();

const getKey = (platform: AnalyticsPlatform, id: string) =>
  `${platform}:${id}`

export const addAnalytics = (platform: AnalyticsPlatform, id: string, report: Report) => {
  analyticsStore.set(getKey(platform, id), report)
};

export const getAnalyticsReport = (platform: AnalyticsPlatform, id: string): Report =>
  analyticsStore.get(getKey(platform, id));
